import React, { useEffect, useState, useCallback } from 'react';
import {
	BREADCRUMB,
	PAGETITLE,
	PAYPALBANNER,
	PRODUCTTILES,
	PROMOMSG
} from '../../constants/rootElements';
import { Breadcrumb } from '../breadcrumb';
import { UplomaProductTiles } from './uplomaProductTiles';
import { TitleBar } from "../productBrowseTitle";
import { AlertsList, EmptyProductsFallback } from '../../components';
import { useFeeAlertInjectionScript } from "../../hooks";
import { AfterPayBanner } from '../../components';
import { useGoogleAnalyticsHandler } from '../../hooks/useGoogleAnalyticsHandler';

export const UplomaPage = ({ appData }) => {
	const [pbData, setPbData] = useState({});
	const [breadcrumbData, setBreadcrupmData] = useState([]);
	const [promoMessages, setPromoMessages] = useState([]);
	const [feeAlertRequestData, setFeeAlertRequestData] = useState(null);
	const [googleAnalyticsRequestData, setGoogleAnalyticsRequestData] = useState(null);
    const [currencyCode, setCurrencyCode] = useState(null);

	useFeeAlertInjectionScript(feeAlertRequestData)
	const { selectItemTrackingGASY25, viewModalTrackingGASY25, addToCartTrackingGASY25 } = useGoogleAnalyticsHandler(googleAnalyticsRequestData);

	const UplomaBreadcrumb = Boolean(
		appData?.pagecontentData?.find((data) => data.contentType === 'Navigation')
	);
	const ProductBrowseProducts = appData?.pagecontentData?.find(
		(data) => data.contentType === 'ProductBrowseProducts'
	);
	const ProductBrowsePromoMsg = Boolean(
		appData?.pagecontentData?.find(
			(data) => data.contentType === 'ProductBrowsePromoMsg'
		)
	);
	const PaypalBannerData = appData?.pagecontentData?.find(
		(data) => data.contentType === 'PaypalId'
	);
	const UplomaTitleBar = appData?.pagecontentData?.find(
		(data) => data.contentType === 'ProductBrowseTitle'
	);

	const getBreadcrumb = useCallback(() => {
		BREADCRUMB.render(
			<Breadcrumb pbData={breadcrumbData} />
		);
	}, [breadcrumbData]);

	const getPromoMsg = useCallback(() => {
		PROMOMSG.render(
			<AlertsList messages={promoMessages} />
		);
	}, [promoMessages]);

	const productTiles = useCallback(() => {
		PRODUCTTILES.render(
			!!pbData?.products?.length
				? <UplomaProductTiles
					pbData={pbData}
					pageContent={ProductBrowseProducts}
					googleAnalytics={{ 
						selectItemTrackingGASY25, 
						viewModalTrackingGASY25, 
						addToCartTrackingGASY25,
						catalogOSR: googleAnalyticsRequestData?.catalogOsr,
						customerClassCode: appData.affiliationData?.customerClassCode
					}}
				/>
				: <EmptyProductsFallback
					productBrowseData={pbData}
				/>
		)
		// eslint-disable-next-line
	}, [pbData, selectItemTrackingGASY25]);

    const paypalBanner = useCallback(() => {
        PAYPALBANNER.render(<AfterPayBanner currencyCode={currencyCode} />);
    },[PaypalBannerData, currencyCode])

	const getTitleBar = useCallback(() => {
		PAGETITLE.render(
			<TitleBar
				pageContent={UplomaTitleBar}
				affiliationData={appData?.affiliationData}
			/>
		);
	}, []);

	useEffect(() => {
		appData.productBrowseData &&
			Object.keys(appData.productBrowseData).map((key) => {
				if (key !== 'metaData') {
					const catalog = appData.productBrowseData[key];
					catalog?.productGroups &&
						Object.keys(catalog.productGroups).map(
							(catObj) => {
								const productGroup = catalog.productGroups[catObj];
								setPbData(productGroup);
								const _currencyCode = productGroup?.products?.[0]?.currencyCode;
								_currencyCode && setCurrencyCode(_currencyCode);
								setPromoMessages(catalog.promoMessages);
								const customerNumber = appData.productBrowseData.metaData.customerNumber;
								setFeeAlertRequestData({
									containerSelector: '#promoMsg',
									customerId: customerNumber,
									catalogOsr: catalog.catalogOsr,
								});
								setGoogleAnalyticsRequestData({
									customerNumber,
									publishedCatalogId: catalog.publishedCatalogId,
									sourceCatalogType: catalog.sourceCatalogType,
									catalogOsr: catalog.catalogOsr,
									customerClassCode: appData.affiliationData?.customerClassCode
								});
								setBreadcrupmData(productGroup);
								return true;
							}
						);
				}
				return true;
			});
	}, [appData.productBrowseData]);

	return (
		<>
			{UplomaBreadcrumb && getBreadcrumb()}
			{UplomaTitleBar && Object.keys(UplomaTitleBar)?.length > 0 && getTitleBar()}
			{ProductBrowsePromoMsg && promoMessages?.length > 0 && getPromoMsg()}
			{ProductBrowseProducts &&
				Object.keys(ProductBrowseProducts)?.length > 0 &&
				productTiles()}
			{PaypalBannerData &&
				Object.keys(PaypalBannerData)?.length > 0 &&
				paypalBanner()}
		</>
	);
};
